import React, { useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, Card, IconButton, CardMedia, Box, TableHead } from "@mui/material";
import { CustomBtn } from "../../../../components/button/button";
import html2canvas from 'html2canvas';
import { useDispatch, useSelector } from "react-redux";
import { Height } from "@mui/icons-material"; 
import '../ishaqNazari.scss'
import { ShowLoader } from '../../../../redux/actions/loader';

// import { headers } from '../../../../hooks/FirstTimeWebSrn/Websrn';
const PrintBillDialog = ({ open, onClose, paymentData }) => {
    // console.log(paymentData)
    const setHeight = paymentData?.inCartProducts.length < 3 ? '250px' : paymentData?.inCartProducts.length < 6 ? '150px' : '55px'
    const hosted = window.location.origin
    const getUrl = useSelector((state) => state.Api);
     
    const dispatch = useDispatch();

    // Helper function to convert image to Base64
    const toBase64 = (url) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
        };
        img.src = url;
    });
    };
    // const headerImg = hosted+'/images/ishaqNazari/uper.png'
    const mustafaLogo = "/images/mustafa/mustafaLogo.png";  // Direct public path
    const uper = "/images/mustafa/header.png";  // Direct public path
    const header = '/images/mustafa/heads.png';
    const eachItem = '/images/mustafa/eachItem.png';
    const name = '/images/mustafa/name.png';
    const bottom = '/images/mustafa/footer.png';
    const totalImage = '/images/mustafa/total.png';

    // //console.log(paymentData?.customer_contact)
    // //console.log(paymentData     )
    const loginUser = localStorage.getItem('loggedInUser')
    let phoneNumber = '';

    if (paymentData?.customer_contact == undefined) {
        let phone = paymentData?.customers[0]?.phone_number?.trim() || '';
        // Remove leading zero if present
        phone = phone.replace(/^0+/, '');
        phoneNumber = '93' + phone;
    } else {
        let phone = paymentData?.customer_contact?.trim() || '';
        // Remove leading zero if present
        phone = phone.replace(/^0+/, '');
        phoneNumber = '93' + phone;
    }
    // //console.log(Number(phoneNumber))
    // const billContentElement = document.getElementById('bill-content');
        const api = useSelector((state) => state.Api); 
        const billContentRef =  useRef(null);

        const handlePrint = async () => {
            const printWindow = window.open('', '_blank');
             const printContent = billContentRef.current.innerHTML;

             // Convert all CSS background images to Base64
            const cssWithImages = `
                <style>
                body { margin: 0; padding: 0; }
                @page { size: auto; margin: 0mm; }
                .nameTable {
                    background-image: url(${await toBase64(`${process.env.PUBLIC_URL}${name}`)}) !important;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .eachItem {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .eachItem tr:nth-child(2){
                    background-color: #f5f4f6
                }
                .totalBackground {
                    background-image: url(${await toBase64(`${process.env.PUBLIC_URL}${totalImage}`)}) !important;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .ishaqNazariBill{
                    background-repeat:no-repeat;
                    background-position:center;
                    background-size:300px; 
                }
                </style>
            `;
            printWindow.document.write(`
                <html>
                <head>
                    <title>Bill</title>
                    ${cssWithImages}
                    <style>
                    body { margin: 0; padding: 0; }
                    @page { size: auto; margin: 0mm; }
                    /* Include all your print-specific styles */
                    </style>
                </head>
                <body onload="window.print();">
                    ${printContent}
                </body>
                </html>
            `);
            printWindow.document.close();
          };
        
          
    const sendBillToWhatsApp = () => {
        const billContentElement = document.getElementById('bill-content');
    
        if (!billContentElement) {
            console.error("Bill content not found!");
            return;
        }
        dispatch(ShowLoader('1'))
    
        // Capture the bill content as an image
        html2canvas(billContentElement, {
            scale: 1, 
            width: billContentElement.scrollWidth, // Capture full width
            height: billContentElement.scrollHeight, // Capture full height
            windowWidth:  billContentElement.scrollWidth, // Capture full width
            windowHeight:  billContentElement.scrollHeight, // Capture full height
         }).then((canvas) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error("Failed to convert canvas to blob");
                    return;
                }
                //console.log(billContentElement.scrollHeight, billContentElement.scrollWidth)
                // Prepare form data for image upload
                const formData = new FormData();
                formData.append("image", blob, "bill.png");
                const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
        
                // Upload the image to the backend server
                fetch(api.uploadBills, {
                    method: "POST",
                    body: formData,
                    headers: {
                        'Authorization': `Bearer ${userToken}`
                    },
                })
                .then((response) => response.json())
                .then((data) => {
                    // //console.log(data?.fileUrl);
                    dispatch(ShowLoader('0'))
                    if (!data.fileUrl) {
                        throw new Error("Image upload failed");
                    }
        
                    const uploadedImageUrl = data?.fileUrl.replace(/\\\\/g, '\\'); // Replace double backslashes with a single backslash
                    const formattedPhoneNumber = Number(phoneNumber);
                    //console.log(getUrl.web+uploadedImageUrl);
                    const customUploadImageUrl = getUrl.web+uploadedImageUrl
        
                    const whatsappLink = `https://wa.me/${formattedPhoneNumber}?text=${encodeURIComponent(
                        `${customUploadImageUrl}`
                        // ` *Check your bill here:*\n\n${uploadedImageUrl}`
                    )}`;
        
                    // Open WhatsApp with the message
                    window.open(whatsappLink, "_blank");
                })
                .catch((error) => {
                dispatch(ShowLoader('0'))
                    console.error("Error uploading image:", error);
                });
            }, "image/png");
        }).catch((error) => {
            console.error("Error capturing bill:", error);
        });
        
    };
    
    const currentDateTime = () => {
        const date = new Date(paymentData?.created_at);
    
        // Custom formatting options
        const options = {
            day: '2-digit',
            month: 'short', // This will give you the abbreviated month (e.g., "Mar")
            year: 'numeric',
            // hour: '2-digit',
            // minute: '2-digit',
            // second: '2-digit',
            // hour12: true // To display in 12-hour format (AM/PM)
        };
    
        // Format date and time
        const formattedDate = date.toLocaleString('en-GB', options).replace(',', ''); // Remove comma if desired
        return formattedDate;
    };   
    const handleThermalPrinter = () => {
        const { ipcRenderer } = window.require('electron');
        ipcRenderer.invoke('print-receipt', {
            items: [
            { name: "Coffee", qty: 2, price: 5.00 },
            { name: "Sandwich", qty: 1, price: 8.50 }
            ],
            total: 18.50
        }).then(result => {
            if (result.success) {
            //console.log('Print successful');
            } else {
            console.error('Print failed:', result.error);
            }
        });
        };
        return (
            <Dialog open={open} onClose={onClose}> 
                <DialogContent>
                <div id="bill-content" ref={billContentRef}  style={{ width: '535px', backgroundColor: 'white', marginLeft:'20px' }}>
                    {/* <Box><h2 style={{ margin:'0px !important', marginLeft:'5% !important'}}>{JSON.parse(localStorage.getItem('Registered')).businessName}</h2></Box>  */}
                    {/* <Box><h2><img src={uper} /></h2></Box> */}
                    <Box><table style={{border:'0px', paddingLeft:'2px', width:'100%'}}><tr style={{background:`url(${process.env.PUBLIC_URL}${uper})`, backgroundRepeat:'no-repeat', width:'533px', height:'125px', textAlign:'center', borderCollapse:'collapse'}}><td style={{border:'0px', borderCollapse:'collapse'}}>
                        {/* <img src={`${process.env.PUBLIC_URL}${uper}`} /> */}
                        </td></tr></table></Box> 
                    {/* <Box><h2><img src={`${hosted}/public/images/ishaqNazari/uper.png`} /></h2></Box>  */}
                    <Box>
                        <table className='nameTable' style={{background:`url(${process.env.PUBLIC_URL}${name})`, backgroundRepeat:'no-repeat', backgroundPositionY:'bottom', width:'533px', height:'32px', textAlign:'center', borderCollapse:'collapse'}}><tr>
                            <td className='custDate' style={{border:'0px', verticalAlign:'top', fontSize:'14px', fontWeight:'bold', textAlign:'center', width:'115px'}}><span>{currentDateTime()}</span></td>
                            <td className='custTrans' style={{border:'0px', verticalAlign:'top', fontSize:'14px', fontWeight:'bold', textAlign:'center', width:'147px'}}><span>{paymentData?.transaction_id}</span></td>
                            <td className='custName' style={{border:'0px', verticalAlign:'top', fontSize:'14px', fontWeight:'bold', textAlign:'center', width:'280px'}}><span>{paymentData?.customerName === undefined ? paymentData?.customer_name  : paymentData?.customerName}</span></td>
                        </tr></table></Box> 
                    <Box>
                        <table className='ishaqNazariBill' style={{borderCollapse:'collapse', backgroundRepeat:'no-repeat', backgroundPosition:'center', backgroundSize:'200px',backgroundPositionY:'50px', backgroundPosition:'center', backgroundImage:`url(${process.env.PUBLIC_URL}${mustafaLogo})`}}>
                            <thead>
                                <tr className="boldi">
                                    {/* <td style={{width:'80px'}}></td> */}
                                    <td style={{width:'532px'}}></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="boldi">
                                    {/* <td style={{width:'4px', verticalAlign:'top'}}>ساخت: واصلي ڼیکنالوژی</td> */}
                                    {/* <td style={{width:'80px', verticalAlign:'top'}}><img src={`${process.env.PUBLIC_URL}${side}`}/></td> */}
                                    <td style={{width:'532px', verticalAlign:'top'}} >
                                        <table style={{borderCollapse:'collapse', width:'100%'}}>
                                            <thead>
                                                <tr style={{lineHeight:'10px', background:`url(${process.env.PUBLIC_URL}${header})`, backgroundRepeat:'no-repeat', width:'532px', height:'33px', textAlign:'center', borderCollapse:'collapse'}}>
                                                    <td colSpan={5}>
                                                        {/* <img src={`${process.env.PUBLIC_URL}${header}`}/> */}
                                                    </td>
                                                </tr>
                                            </thead>
                                                <tbody>
                                            {paymentData?.inCartProducts?.map((product, key) => ( //background:`url(${process.env.PUBLIC_URL}${eachItem})`,
                                                <tr className='eachItem' key={key} style={{ backgroundRepeat:'no-repeat', lineHeight:'10px', backgroundRepeat:'no-repeat', height:'36px', borderBottom:'2px dotted #e1e1e1', width:'532px', textAlign:'center' }}>
                                                    <td style={{border: '0px', width:'95px'}}>{(product?.selling_price * product?.quantity_sold)?.toFixed(2)}</td>
                                                    <td style={{border: '0px', width:'87px'}}>{product?.selling_price}</td>
                                                    <td style={{border: '0px', width:'69px'}}>{product?.quantity_sold }</td>
                                                    <td style={{border: '0px', width:'229px', backgroundColor:'f5f4f6', textAlign:'right', paddingRight:'10px'}}>{product?.product_name} {product?.product_id}</td>
                                                    <td style={{border: '0px', width:'51px'}}>  {key+1}  </td>
                                                </tr>  
                                            ))} 
                                                </tbody> 
                                            <tfoot>
                                                {/* {paymentData?.discount_amount > 0? 
                                                    <tr>
                                                        <td>{paymentData?.discount_amount} </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>تخفیف</td>
                                                    </tr> background:`url(${process.env.PUBLIC_URL}${bottom})`, 
                                                    : null } */}
                                                    
                                                    <tr className="boldi total totalBackground" style={{height:setHeight, background:`url(${process.env.PUBLIC_URL}${totalImage})`, height:'38px', lineHeight:'10px', backgroundRepeat:'no-repeat', width:'532px', textAlign:'center'}}>
                                                        <td colSpan={2} style={{border:'0px', textAlign:'left', paddingLeft:'46px'}}>{parseFloat(paymentData?.total_amount)?.toFixed(2)}</td>
                                                        <td style={{border:'0px'}}></td>
                                                        <td style={{border:'0px'}}></td>
                                                        <td style={{border:'0px'}}></td>
                                                    </tr>
                                                    
                                                    <tr className="boldi total" style={{verticalAlign:'bottom',lineHeight:'10px', height:'0px', backgroundRepeat:'no-repeat', width:'532px', textAlign:'center'}}>
                                                        <td colSpan={5} style={{border:'0px', textAlign:'right'}}>
                                                            <img src={`${process.env.PUBLIC_URL}${bottom}`}/>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={5} style={{width:'4px', textAlign:'right', verticalAlign:'top', color:'rgb(149 149 149)'}}>www.Wasily.net ساخت: واصلي ټیکنالوژی</td>
                                                    </tr>
                                            </tfoot>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                {/* <td colSpan={3}>SalesPerson: {loginUser}</td> */}
                            </tr>
                            {/* <tr>
                                <td className="pashtoThanks" colSpan={4}>ستاسو د راتګ څخه مننه</td>
                            </tr> */}
                            {/* <tr>                                
                                <td colSpan={2} style={{textAlign:'center'}}>ساخت: واصلي ڼیکنالوژی </td>
                            </tr>
                            <tr>
                                <td colSpan={2} style={{textAlign:'center'}}> <b>0703131865</b>   <b>www.Wasily.net</b></td>

                            </tr> */}
                            {/* <tr>                                
                                <td style={{textAlign:'center'}}> <b>0703131865</b></td>
                                <td> <b>www.Wasily.net</b></td>
                            </tr> */}
                        </tfoot>
                        </table>
                    </Box>
                    {/* <Box><p className='loanOrcash' style={{marginLeft:'20%'}}>{paymentData?.payment_method === 'LOAN'? 'پور': 'نغد'}</p></Box>  */}
                    {/* <Box><p>Recipt #: {paymentData?.transaction_id}  <span style={{fontSize:'18px', marginLeft:'20px', fontWeight:'bold'}}>{paymentData?.payment_method === 'LOAN'? 'پور': 'نغد'}</span></p></Box>  */}
                    {/* <Box><p>Date: {currentDateTime()}</p></Box>  */}
                        
                    </div>
                </DialogContent>
                <Grid container lg={12} className='bottomTotal'>
                    <Grid xs={4} lg={4}>
                        <DialogActions>
                            <Button onClick={onClose} color="primary" variant="contained">OK</Button>
                            {/* <Button onClick={handleThermalPrinter} color="primary" variant="contained">OK</Button> */}
                        </DialogActions>
                    </Grid>
                    <Grid xs={4} lg={4}>
                        <DialogActions>
                            <Button onClick={handlePrint} color="primary" variant="contained">Print</Button>
                        </DialogActions>
                    </Grid>
                    <Grid xs={4} lg={4}>
                        {/* <DialogActions>
                            <Button color="primary" onClick={sendBillToWhatsApp} variant="contained">WhatsApp</Button>
                        </DialogActions> */}
                    </Grid>
                </Grid>



            </Dialog>
        );
    };

    export default PrintBillDialog;
